import React, { Fragment } from 'react';
import { css } from 'styled-components';

import ValuePropBase from './ValuePropBase';
import { breakpoints, palette } from '../../constants/styles';
import Helmet from 'react-helmet';

const StyledTitle = css`
  max-width: 290px;
  color: #022759;

  ${breakpoints.tablet} {
    text-align: center;
    max-width: 430px;
  }

  ${breakpoints.tabletLandscape} {
    text-align: left;
    max-width: 300px;
    margin-bottom: 20px;
  }
`;

const StyledMainTitle = css`
  max-width: 290px;
  line-height: 1.2;
  margin-top: 60px;

  ${breakpoints.tablet} {
    margin-top: 60px;
    text-align: center;
    max-width: 430px;
  }

  ${breakpoints.tabletLandscape} {
    display: none;
    text-align: left;
    max-width: 300px;
  }
  color: ${palette.primaryColor};
  text-align: center;
`;

const styledMessage = css`
  width: 55%;
  text-align: center;
  ${breakpoints.tablet} {
    width: 100%;
  }
  ${breakpoints.tabletLandscape} {
    text-align: left;
    max-width: 134px;
  }
`;

const Plan = () => (
  <Fragment>
    <Helmet>
      <title>{'Finauta | Plan'}</title>
    </Helmet>
    <ValuePropBase
      pixelText="Clicked start plan"
      tool="plan"
      title="Recupera el control de tus finanzas"
      titleStyles={StyledTitle}
      mainTitle="Plan financiero"
      message="Anónimo y en menos de 5 minutos"
      mainTitleStyles={StyledMainTitle}
      messageStyles={styledMessage}
    />
  </Fragment>
);

export default Plan;
